
import React, { useEffect, useState } from 'react'
import { printDto } from '../../../api/interfaces/Posts';
import { API_ENDPOINTS } from '../../../api';
import { getService } from '../../../servce/ApisService';
import { useLoader } from '../../../Loader/LoaderContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

function ViewPrintAd() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
   const [searchParams] = useSearchParams();
                const userId = searchParams.get('appUserId');
const navigate=useNavigate();
  const { setLoading } = useLoader();
    const [submittedData, setSubmittedData] = useState<printDto | null>(null);
  useEffect(() => {
      if (userId) {
        fetchVehicles();
      }
    }, [userId]);
    const downloadFile = (fileUrl:string, fileName:string) => {
      if (!fileUrl) {
        alert("File URL is missing!");
        return;
      }
    
      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName || "downloaded-file"); // Suggest file name
      link.target = "_blank"; // Open in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  const fetchVehicles = async () => {
      setLoading(true);
      try {
        const response = await getService(`${API_ENDPOINTS.getPrintAdData}?id=${userId}`);
        setSubmittedData(response.data);
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      } finally {
        setLoading(false);
      }
    };
    const viweEdit=(data:any)=>{
      navigate('/vendorDashboard/activateDashbord/printAd/addBanner?appUserId='+data?.id)
    }
    const users=()=>{
      navigate('/vendorDashboard/activateDashbord/printAd')
    }
  return (
    <div className="h-full py-2 w-full p-8">
      
        <div className="flex items-center mt-2 cursor-pointer justify-between  mb-4">
          <div className="flex items-center cursor-pointer">
            <h2
              className="mr-2 text-gray-700 font-semibold text-sm"
              onClick={() => users()}
            >
           Banner Ads - Website
            </h2>{" "}
            <img src="/images/arrowIcons.svg" className="mr-2 cursor-pointer"  />{" "}
            <span className="text-gray-400 font-semibold text-sm">
            #{submittedData?.uuid}
            </span>
          </div>
         
        </div>
        <div className='flex justify-between mb-2'>
        <div className='flex items-center text-[#2D2E2F] font-bold text-2xl mb-3 '>  <img src='/images/back.svg' className="mr-2 cursor-pointer" onClick={() => users()} />#{submittedData?.uuid}</div>
        <div className="flex items-center">
        {(userInfo?.roles === 'PUBLISHER') &&
            <button className='border border-gray-300 flex items-center justify-center gap-1 py-2 px-3 rounded-lg mr-4 bg-white text-sm' type="button" onClick={()=>viweEdit(submittedData ? submittedData : null)}>
            <img src='/images/editIcon.svg' alt="Edit" />
            Edit </button>}
             
          </div>
        </div>
        <div className='p-8 bg-white'>

<div className='grid grid-cols-1 pb-6'>
    <div className='flex justify-between'>
        <div>
            <p className='text-gray-700 font-normal text-sm'>Caption</p>
            <p className='text-gray-900 font-semibold text-base mt-2'>{submittedData?.caption}</p>
        </div>
    </div>
</div>
<div className='grid grid-cols-1 pb-6'>
    <div className='flex justify-between'>
        <div>
            <p className='text-gray-700 font-normal text-sm'>Notes</p>
            <p className='text-gray-900 font-semibold text-base mt-2'>{submittedData?.notes || 'NA'}</p>
        </div>
    </div>
</div>
<div className='grid grid-cols-2 gap-4'>
    <div className='flex justify-between'>
        <div>
            <p className='text-gray-700 font-normal text-sm'>Banner</p>
            <p className='border border-[#E7E7E7] rounded-xl p-3 px-5 mt-2 flex justify-between w-[300px]'><div>
                           <h2 className="text-[#0B0B0B] font-semibold text-xs">
                           {submittedData?.fileDto?.name}
                           </h2>
                           <p className="text-[#6D6D6D] text-sm font-normal">
                           {submittedData?.fileDto?.size || ''}
                           </p>
                         </div>
                         <div className="flex items-center cursor-pointer">
                         {/* Refresh image that triggers file input */}
                         <span className="w-[50%]">
                         <img 
                             src="/images/downloadSmbl.svg"
                             alt="Delete"
                             className="max-w-xs cursor-pointer" onClick={()=>downloadFile(submittedData?.fileDto?.documentUrl ? submittedData?.fileDto?.documentUrl : '',submittedData?.fileDto?.name ? submittedData?.fileDto?.name : '')}
                           />
                         </span>
                        
                       </div></p>
        </div>
   

    </div>
    
    <div></div>

</div>
        </div>
      
    </div>
  )
}


export default ViewPrintAd
